<app-modal
  #modal
  class="call-notes-modal"
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  header="ADD NOTE"
  (onShow)="show()"
  (onHide)="hide()">

  <p *ngIf="isAidScoped" class="call-notes-modal__scope-hint">
    Adding note for {{selectedAidCount}} selected AID{{selectedAidCount === 1 ? '' : 's'}}.
  </p>

  <form-factory [formGroup]="formGroup" [model]="callNotes"></form-factory>

  <footer>
    <app-button text="SUBMIT NOTE" (onClick)="saveCallNotes()"></app-button>
  </footer>

</app-modal>